import { townColorHex as hex, shadeTownColor as darken } from './townPropTemplates';
import type { TownPropPalette } from './townPropTemplates';

/** Original unnamed dock body, including whitespace, preserved for other maps. */
export function dockBody(plank: number): string {
  const p = hex(plank);
  const pDark = hex(darken(plank, 0.78));
  return `
    <rect x="0" y="10" width="140" height="9" rx="2" fill="${p}" />
    <path d="M20 10 v9 M40 10 v9 M60 10 v9 M80 10 v9 M100 10 v9 M120 10 v9"
      stroke="${pDark}" stroke-width="1.3" opacity="0.8" />
    <rect x="0" y="19" width="140" height="4" fill="${pDark}" />
    <rect x="130" y="0" width="8" height="19" rx="2" fill="#4a3020" />
    <rect x="10" y="23" width="7" height="30" fill="#4a3020" />
    <rect x="52" y="23" width="7" height="30" fill="#4a3020" />
    <rect x="94" y="23" width="7" height="30" fill="#4a3020" />
    <rect x="10" y="44" width="7" height="9" fill="#32200f" />
    <rect x="52" y="44" width="7" height="9" fill="#32200f" />
    <rect x="94" y="44" width="7" height="9" fill="#32200f" />
    <ellipse cx="13.5" cy="52" rx="9" ry="2.5" fill="#4a3a5a" opacity="0.5" />
    <ellipse cx="55.5" cy="52" rx="9" ry="2.5" fill="#4a3a5a" opacity="0.5" />
    <ellipse cx="97.5" cy="52" rx="9" ry="2.5" fill="#4a3a5a" opacity="0.5" />`;
}

/** Low, separate furnishings in a 140×56 frame. No decorative walking surface. */
export function buildQuayCargoBody(p: TownPropPalette): string {
  const wood = hex(p.primary), edge = hex(p.woodEdge), shade = hex(p.shade);
  const iron = hex(p.iron), rope = hex(p.stone), highlight = hex(p.roofEdge);
  return `
    <g data-part="west-mooring">
      <path d="M3 56V53H5V40H10V53H12V56Z" fill="${iron}" />
      <path d="M4 40H11V43H4Z" fill="${shade}" />
      <path d="M5 41H10 M6 44V51" fill="none" stroke="${highlight}" stroke-width="0.8" />
      <path d="M4 48Q8 45 11 48 M4 50Q8 47 11 50" fill="none" stroke="${rope}" stroke-width="1.3" />
    </g>
    <g data-part="cargo">
      <path d="M45 56V34L50 31H71L76 35V56Z" fill="${wood}" />
      <path d="M45 34H70L76 35H51Z" fill="${edge}" />
      <path d="M70 35H76V56H70Z" fill="${shade}" />
      <path d="M46 36H69V54H46Z M47 37L68 53 M68 37L47 53" fill="none" stroke="${edge}" stroke-width="1.6" />
      <path d="M53 36V53 M62 36V53 M71 38V53" fill="none" stroke="${shade}" stroke-width="0.9" />
      <path d="M50 32H71 M73 38V53" stroke="${highlight}" stroke-width="0.65" opacity="0.65" />
      <path d="M81 38Q85 36 89 38L89 52Q89 56 81 56Q79 52 81 38Z" fill="${wood}" />
      <path d="M82 39L82 53 M86 39V55 M88 40L88 53" fill="none" stroke="${shade}" stroke-width="0.7" />
      <path d="M81 42Q85 44 89 42 M80 51Q85 53 89 51" fill="none" stroke="${iron}" stroke-width="1.5" />
      <ellipse cx="85" cy="38" rx="4" ry="1.5" fill="${edge}" />
    </g>
    <g data-part="east-mooring">
      <ellipse cx="122" cy="54" rx="10" ry="1.6" fill="${iron}" opacity="0.25" />
      <path d="M122 56V52H124V39H129V52H131V56Z" fill="${iron}" />
      <path d="M122 39H131V42H122Z" fill="${shade}" />
      <path d="M124 40H129 M125 43V51" fill="none" stroke="${highlight}" stroke-width="0.8" />
      <ellipse cx="117" cy="53" rx="5" ry="2" fill="none" stroke="${rope}" stroke-width="1.5" />
      <ellipse cx="117" cy="53" rx="2.7" ry="0.9" fill="none" stroke="${edge}" stroke-width="0.8" />
      <path d="M121 53Q130 53 133 55" fill="none" stroke="${rope}" stroke-width="1.1" />
    </g>`;
}
